import React, { useMemo } from 'react';
import { useLocation } from '@react-router';

import { useTranslation } from '@shared/core';
import { OG_IMAGE } from '@shared/constants/seo';
import { buildHotelSearchOgContent } from './hotelSearchOgContent';
import { LinkPreviewHead } from '@shared/components/LinkPreviewHead';
import { useEventLocaleFormatter } from '@shared/core/localization/hooks/useEventLocaleFormatter';

/** Server-rendered preview tags for the hotel search page, built from the URL alone. */
export const HotelSearchHead: React.FC = () => {
  const { pathname, search } = useLocation();
  const { tq } = useTranslation('hotelSearchGuest');
  const { formatDateRange } = useEventLocaleFormatter();

  const { destination, dateRange, canonicalUrl } = useMemo(() => buildHotelSearchOgContent(pathname, search), [pathname, search]);
  const dates = dateRange ? formatDateRange(dateRange.checkInDate, dateRange.checkOutDate) : undefined;

  const title = destination ? (dates ? tq`Hotels near ${destination} · ${dates}` : tq`Hotels near ${destination}`) : dates ? tq`Hotel search · ${dates}` : tq`Hotel search`;
  const description = destination ? tq`Search hotels near ${destination}.` : tq`Search hotels for your trip.`;

  return (
    <LinkPreviewHead
      title={title}
      url={canonicalUrl}
      imageUrl={OG_IMAGE}
      imageAlt={tq`Joy logo`}
      description={description}
    />
  );
};
